import base from "./types/base"
class ResponseHelper{
    handleError(vm:any, error:any){
        let response = error.response.data;
        let isSuccess = response && response.success;
        //发生错误
        if(!isSuccess){
            (() => {
                if(error.response.status == 302 || error.response.headers["token_expired"]){
                    location.reload();
                    return;
                }
                //未知错误
                if (!response || !response.error){
                    this.warningModal(vm,{
                        title: base.L('MessageTitle.Tips'),
                        content: base.L('MessageTitle.UnknownError')
                    });
                    return;
                }

                let errorInfo = response.error;

                //Model Validation 错误(ICustomValidate)
                if (errorInfo.validationErrors && (errorInfo.validationErrors as Array<object>).length > 0){
                    let valid = {};
                    let otherError = [];
                    errorInfo.validationErrors.forEach(e => {
                        let name = e.members ? (e.members as Array<string>)[0] : '';

                        if (!name){
                            otherError.push(e.message);
                        }

                        if (!valid[name]){
                            valid[name] = e.message;
                            return;
                        }
                        valid[name] = valid[name] + '|' + e.message;
                    });
                    
                    if (otherError.length > 0){
                        this.warningModal(vm,{ title: base.L('MessageTitle.Tips'), content: otherError.join('</br>')});
                        return;
                    }
                    error.response.modelValidationErrors = valid;
                    return;
                }
                
                //Model Validation 错误(ValidateException)
                if (errorInfo.code === 1){
                    let valid = JSON.parse(errorInfo.message);
                    if (valid['']){
                        this.warningModal(vm,{
                            title: base.L('MessageTitle.Tips'),
                            content: valid[''].join('</br>')
                        });
                        return;
                    }

                    Object.keys(valid).forEach(e => { valid[e] = valid[e].join('|'); });
                    error.response.modelValidationErrors = valid;
                    return;
                }

                if (errorInfo.details) {
                    //业务错误提示
                    if ((errorInfo.details as string).indexOf('UserFriendlyException') >= 0){
                        this.warningModal(vm,{
                            title: base.L('MessageTitle.UserFriendlyError'),
                            content: errorInfo.message
                        });

                        return;
                    }

                    //业务错误提示
                    this.warningModal(vm,{
                        title: '[' + base.L('MessageTitle.Tips') + ']' + errorInfo.message,
                        content: errorInfo.details
                    });
                    return;
                }

                //其他提示
                this.warningModal(vm,{
                    title: base.L('MessageTitle.Tips'),
                    content: errorInfo.message
                });
            })();

        }
    }
    warningModal(vm:any, {title, content}){
        setTimeout(()=>{
            vm.$Modal.warning({
                title: title,
                content: content
            });             
        }, 500);
    }
}

export const responseHelper = new ResponseHelper();